import { Badge } from "@chakra-ui/react";
import { ChecklistStatus } from "hooks/useChecklist";

const CheckListStatusBadge = ({ status }: { status?: string | null }) => {
  const statusText = (status ?? ChecklistStatus.Pending).toLocaleLowerCase();

  const color = {
    [ChecklistStatus.Pending]: {
      background: "#FEF8E9",
      color: "#F2B821",
    },
    [ChecklistStatus.Reviewed]: {
      background: "#E5E9FF",
      color: "#2746E5",
    },
    [ChecklistStatus.Approved]: {
      background: "green.100",
      color: "green.600",
    },
    [ChecklistStatus.Rejected]: {
      background: "red.100",
      color: "red.600",
    },
  };
  return (
    <Badge fontSize="12px" textTransform={"capitalize"} {...(color[statusText as keyof typeof color] || {})}>
      {statusText}
    </Badge>
  );
}

export default CheckListStatusBadge;
